import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { TextareaComponent } from './textarea.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [
    TextareaComponent
  ],
  exports: [
    TextareaComponent,
  ]
})
export class TextareaModule {
}
